module.exports = __webpack_public_path__ + "img/170.f240b166.jpg";